import { Model } from 'pinia-orm';

export default class SeekQuestionnaire extends Model {

    static get entity() {
        return 'seek-questionnaire'
    }

    static fields() {
        return {
            id: this.uid(),
            application_id: this.attr(null),
            overall_score: this.attr(0),
            questions: this.attr(null),
            privacy: this.attr(null),
        }
    }
}
